import {
    Switch as HeroSwitch,
    type SwitchProps as HeroSwitchProps,
    switchVariants as heroSwitchVariants,
} from "@heroui/react";
import { tv, type VariantProps } from "tailwind-variants";
import { cn } from "../utils/cn.util";

const switchVariants: ReturnType<typeof tv> = tv({
    extend: heroSwitchVariants,
    base: cn("h-6 w-10 rounded-full"),
});

type SwitchVariants = VariantProps<typeof switchVariants>;
interface SwitchProps
    extends Omit<HeroSwitchProps, "className" | "variant" | "size">,
        SwitchVariants {
    className?: string;
    label?: React.ReactNode;
    labelPosition?: "start" | "end";
}

export function Switch({
    className,
    label,
    labelPosition = "end",
    ...props
}: SwitchProps) {
    return (
        <HeroSwitch.Root {...props} size="lg">
            {({ isSelected }) => (
                <HeroSwitch.Content className={cn("items-center gap-8", className)}>
                    {label && labelPosition === "start" && label}

                    <HeroSwitch.Control
                        className={cn(
                            "h-32 w-[52px] bg-status-inactive",
                            isSelected && "bg-status-success",
                        )}
                    >
                        <HeroSwitch.Thumb
                            className={cn(
                                "!ms-2 size-[28px] shadow-sm transition-all",
                                isSelected && "translate-x-5",
                            )}
                        />
                    </HeroSwitch.Control>

                    {label && labelPosition === "end" && label}
                </HeroSwitch.Content>
            )}
        </HeroSwitch.Root>
    );
}
